import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c7951a48"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "form-label fw-bold w-100"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_4 = {
  key: 2,
  class: "mas text-primary float-end"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 0,
  class: "position-relative d-inline-block"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "text-muted" }
const _hoisted_10 = { class: "overlay position-absolute w-100 h-100 d-flex justify-content-center align-items-center" }
const _hoisted_11 = { class: "d-flex align-items-center text-primary" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas me-2" }, "file_upload", -1))
const _hoisted_13 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlertError2 = _resolveComponent("AlertError2")!
  const _component_base_spinner = _resolveComponent("base-spinner")!
  const _component_BaseDeleteButton = _resolveComponent("BaseDeleteButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("label", _hoisted_1, [
          _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
          (_ctx.isMultilingual)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, "(" + _toDisplayString(_ctx.language.toUpperCase()) + ")", 1))
            : _createCommentVNode("", true),
          (_ctx.isRequired)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, "*"))
            : _createCommentVNode("", true),
          (_ctx.isMultilingual)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, "language"))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_AlertError2, {
      error: _ctx.pageUI.getError()
    }, null, 8, ["error"]),
    (_ctx.pageUI.isNotReady() || _ctx.pageUI.isSubmitting())
      ? (_openBlock(), _createBlock(_component_base_spinner, { key: 1 }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _withDirectives(_createElementVNode("img", {
            src: _ctx.previewUrl,
            alt: "preview",
            class: "hover-image shadow"
          }, null, 8, _hoisted_5), [
            [_vShow, _ctx.previewUrl && !_ctx.isDocument && _ctx.showFullSizePreviewOnHover && _ctx.isHovering]
          ]),
          (_ctx.previewUrl && !_ctx.isDocument)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("img", {
                  onMouseover: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setIsHovering(true))),
                  onMouseout: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setIsHovering(false))),
                  src: _ctx.previewUrl,
                  style: _normalizeStyle({ maxHeight: _ctx.maxHeight, width: 'auto', height: 'auto', cursor: _ctx.showFullSizePreviewOnHover ? 'pointer' : 'default' }),
                  class: "img-fluid",
                  alt: "preview uploaded image"
                }, null, 44, _hoisted_7),
                (_ctx.canBeDeleted)
                  ? (_openBlock(), _createBlock(_component_BaseDeleteButton, {
                      key: 0,
                      deleteData: _ctx.deleteDocument,
                      pageUI: _ctx.pageUI,
                      class: "position-absolute",
                      style: {"top":"6px","right":"6px"}
                    }, null, 8, ["deleteData", "pageUI"]))
                  : _createCommentVNode("", true)
              ]))
            : (_ctx.previewUrl && _ctx.isDocument)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("small", _hoisted_9, _toDisplayString(_ctx.$t('selectedFile')) + ": " + _toDisplayString(_ctx.fileName), 1),
                  (_ctx.canBeDeleted)
                    ? (_openBlock(), _createBlock(_component_BaseDeleteButton, {
                        key: 0,
                        deleteData: _ctx.deleteDocument,
                        pageUI: _ctx.pageUI,
                        class: "ms-2"
                      }, null, 8, ["deleteData", "pageUI"]))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  class: "dropzone position-relative w-100",
                  style: _normalizeStyle({height: _ctx.maxHeight}),
                  onDragover: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.dragover && _ctx.dragover(...args))),
                  onDragleave: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.dragleave && _ctx.dragleave(...args))),
                  onDrop: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.drop && _ctx.drop(...args)))
                }, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("span", _hoisted_11, [
                      _hoisted_12,
                      _createTextVNode(_toDisplayString(_ctx.$t('uploadFile', {maxSize: _ctx.maxFileSize})), 1)
                    ])
                  ]),
                  _createElementVNode("input", {
                    onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleChosenFile && _ctx.handleChosenFile(...args))),
                    ref: `fileupload-${_ctx.id}`,
                    id: _ctx.id,
                    type: "file"
                  }, null, 40, _hoisted_13)
                ], 36))
        ], 64))
  ], 64))
}